import React from "react";

type CardLabelStatusProps = {
  label: string;
  className?: string;
};

const CardLabelStatus = ({ label, className }: CardLabelStatusProps) => {
  return (
    <div
      className={`inline-flex min-h-4 justify-center items-center gap-2.5 rounded border border-black/8 bg-gradient-botb px-1.5 py-0.5 border-solid ${className ? className : ""}`}>
      <span className={"text-white font-jost text-[11px] font-medium leading-[14px] whitespace-break-spaces"}>
        {label}
      </span>
    </div>
  );
};

export default CardLabelStatus;
